import { render, staticRenderFns } from "./RubricaSettingsModal.vue?vue&type=template&id=fe7d9486&lang=pug"
import script from "./RubricaSettingsModal.vue?vue&type=script&lang=js"
export * from "./RubricaSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./RubricaSettingsModal.vue?vue&type=style&index=0&id=fe7d9486&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports